import './app/publicPath';

const Vue = window.Vue;

Vue.component('ergo-core', () => import('~/app/components/ErgoCore.vue'));
Vue.component('ergo-widget', () => import('~/app/components/ErgoWidget.vue'));
Vue.component('ergo-basket-widget', () => import('~/app/components/ErgoBasketWidget.vue'));
Vue.component('ergo-insurance', () => import('~/app/components/ergo-insurance'));
